import { get, post } from "./index";

// 接口参数类型定义
interface PageParams {
  page: number;
  size: number;
  name?: string;
  projectId?: string | number;
}

interface DetailParams {
  id: string | number;
}

interface PurchaseSignParams {
  id: string | number;
}

// 响应数据类型定义
interface NFTItem {
  id: string | number;
  name: string;
  tokenId: string;
  price: string;
  status: number;
  saleTime: string;
  imageResource: {
    url: string;
  };
  contractAddress?: string;
}

interface PageResponse<T> {
  content: T[];
  total: number;
  page: number;
  size: number;
}

interface ProjectItem {
  id: string | number;
  name: string;
}

interface PurchaseSignResponse {
  sign: string;
  price: string;
  tokenId: string;
  receiveAddress: string;
  to: string;
  timestamp: string;
  tokenUri: string;
  contractAddress: string;
}

interface MintRecord {
  id: string | number;
  nftInfo?: {
    name: string;
  };
  price: string;
  mintTime: string;
  tx: string;
}

// NFT相关接口
export const nftApi = {
  /**
   * 获取NFT列表
   * @param params 分页参数
   */
  getPage(params: PageParams) {
    return get<PageResponse<NFTItem>>("/nft", params);
  },

  /**
   * 获取NFT详情
   * @param params 详情参数
   */
  getDetail(params: DetailParams) {
    return get<NFTItem>(`/nft/${params.id}`);
  },

  /**
   * 获取购买签名
   * @param params 签名参数
   */
  getPurchaseSign(params: PurchaseSignParams) {
    const { id, ...restData } = params;
    return post<PurchaseSignResponse>(`/nft/purchase/sign/${id}`, restData);
  },

  /**
   * 获取项目列表
   */
  getProjects() {
    return get<ProjectItem[]>("/project");
  },

  /**
   * 获取铸造记录
   * @param params 分页参数
   */
  getMintRecords(params: PageParams) {
    return get<PageResponse<MintRecord>>("/nft/mint/record/paging", params);
  },
};

// 为了保持向后兼容，也可以导出单独的函数
export const nftPageApi = (params: PageParams) => nftApi.getPage(params);
export const nftDetailApi = (params: DetailParams) => nftApi.getDetail(params);
export const nftPurchaseSignApi = (params: PurchaseSignParams) =>
  nftApi.getPurchaseSign(params);
export const projectListApi = () => nftApi.getProjects();
export const recordListApi = (params: PageParams) =>
  nftApi.getMintRecords(params);
